import { render, staticRenderFns } from "./UpdateUserInfo.vue?vue&type=template&id=212a9f64&scoped=true"
import script from "./UpdateUserInfo.vue?vue&type=script&lang=js"
export * from "./UpdateUserInfo.vue?vue&type=script&lang=js"
import style0 from "./UpdateUserInfo.vue?vue&type=style&index=0&id=212a9f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../hotel-wc-product/hotel-wc/sources/client/hotel-wc-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212a9f64",
  null
  
)

export default component.exports